import {useContext} from 'react'
import {SalesRepReportContext} from '../../context'
import {DynamicTable} from '../../../../components/DynamicTable'
import {SALES_REP_REPORT_COLUMNS} from '../../utils'
import SalesRepReportRow from './SalesRepReportRow'
import {parseSalesRepReportRow} from '../../parsings'
import {formatPrice} from '../../../../utils/common'

const SalesRepReportTable = () => {
  const {salesRepData, isSalesRepLoading, onSalesRepSortingChange, salesRepFilters} =
    useContext(SalesRepReportContext)

  return (
    <DynamicTable
      data={salesRepData}
      sortableColumns={SALES_REP_REPORT_COLUMNS}
      loading={isSalesRepLoading}
      TableRow={SalesRepReportRow}
      noDataMessage='No sales rep reports found'
      onSortingChange={onSalesRepSortingChange}
      tableClass='table table-row-dashed table-row-gray-300 align-middle gs-0 gy-2'
      rowParsingFunction={parseSalesRepReportRow}
      filters={salesRepFilters}
      tableFooter={({columnTotals}: any) => (
        <tfoot className='border-top border-gray-200 text-dark fw-bolder'>
          <tr>
            <td colSpan={3}>TOTAL</td>
            <td>{columnTotals?.total_order_count}</td>
            <td>{formatPrice(columnTotals.total_shipping, false)}</td>
          </tr>
        </tfoot>
      )}
    />
  )
}

export default SalesRepReportTable
